import faker from 'faker';
import { useFormat } from '@ideavivat/vivat-2';

export default {
  types: {
    _primaryControls: {
      width: '3rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
    },
    employeeCode: {
      name: 'รหัสพนักงาน',
      width: '1fr',
    },
    firstName: {
      name: 'ชื่อพนักงาน',
      width: '1fr',
    },
    // lastName: {
    //   name: 'นามสกุล',
    //   width: '10rem',
    // },
    roles: {
      name: 'ประเภทผู้ใช้งาน',
      width: '8rem',
    },
    _activeControls: {
      name: 'สถานะ',
      width: '3rem',
    },
    lastAccess: {
      name: 'เข้าใช้งานล่าสุด',
      width: '9rem',
      class: 'text-right',
      // mock: new Array(10).fill('').map(() => faker.date.past()),
      filter(val: any) {
        return useFormat.date(val).displayShortThaiDate();
      },
    },
  },
  columns: ['_primaryControls', '_increment', 'employeeCode', 'firstName', 'roles', '_activeControls', 'lastAccess'],
  // sortable: [],
};
